var exports = {
  "uW": "x31de4314--baeb79--section",
  "p_": "x31de4314--baeb79--list",
  "fi": "x31de4314--baeb79--column",
};

module.exports = exports;
